import Question from "./Question.js"
import UserInfo from "./UserInfo.js"
import { v1 as UUID } from "uuid";
import store from '@/store/index'
let examQuestionTypeArr = store.state.examQuestionTypeArr // 计分题
// 问卷类
let Paper = function () {
    this.title = `<p style="text-align: center;"><span style="font-size: 20px"><strong><span style="color: #10ab97;">考试标题</span></strong></span></p>` // 项目名称（考试）
    this.depict="感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！"; // 项目描述
    this.totalScore = 0 // 试卷总分
    this.pageCount = 0 // 页码类型总数
    this.quesCount = 0 // 试题类型总数
    this.quesAtive = '' // 当前选中项
	this.endPageType = 0 // 完成的状态 0 正常 1 提前
	this.endPageNormalMsg = '<p style="text-align: center;">提交成功，感谢参与</p>' // 正常完成 结束页提示语
	this.endPageAdvanceMsg = '<p style="text-align: center;">不好意思，您不符合本次考试条件，谢谢您的参与</p>' // 提前完成 结束页提示语
    this.questionsList = new Array();
    this.cancleEdit = function(){
        // console.log(this.questionsList)
        //取消所有问题的编辑状态
        for(var i=0;i<this.questionsList.length;i++)
        {   
            if (this.questionsList[i].isedit == true) {
                this.quesAtive = this.questionsList[i].qid
            }
            this.questionsList[i].isedit = false;
        }
    },
    // 删除一个问题
    this.delQuestion = function(qid){
        for(var i = 0;i<this.questionsList.length;i++)
        {
            if(qid == this.questionsList[i].qid)
            {
                this.questionsList.splice(i, 1)
                break; 
            }
        }
    },
    /**
     * 
     * @param {*} qType 试题类型
     * @param {*} selectIndex 
     * @param {*} qLevel2Type // 试题二级类型
     * @param {*} bankId // 题库id
     */
    this.createQuestion = function (qType, selectIndex, qLevel2Type, bankId) {
        // console.log("创建试题",qType, selectIndex, qLevel2Type, bankId);
        if (qType == 600) {
            var q = new UserInfo()
            q.infoName = qLevel2Type;
        } else {
            var q = new Question()
        }
        q.qid = UUID();
        if (bankId) {
            q.bqid = q.qid
            q.bid = bankId
        }
        q.questionsTypeId = qType;
        if (qType == 101 || qType == 206) {
            q.partialScore = 5 // 少选可得分（多选）、每答出一个关键词 （简答）
        }
        if (examQuestionTypeArr.indexOf(qType) != -1) {
            let index = 0
            q.score = 5 // 试题分数(默认分数)
            this.questionsList.forEach((item) => {
                if (examQuestionTypeArr.indexOf(item.questionsTypeId) != -1) {
                    index++
                }
            })
            q.quesIndex = index
            this.quesCount++
        }
        // console.log(qType)
        switch (qType) {
            case 100:
                q.questionsName = "我是单选";
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.relation = [{
					id: ''
				}] // 试题关联选项的试题id
				q.associated = [] // 被关联的试题id
                q.createDefaultOption();
                break;
            case 101:
                q.questionsName = "我是多选";
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
				q.relation = [{
					id: ''
				}] // 试题关联选项的试题id
				q.associated = [] // 被关联的试题id
                q.createDefaultOption();
                break;
            case 102:
                q.questionsName = "我是判断";
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
                q.createDefaultOption();
                break;
            case 204:
                q.questionsName = "我是填空";
                q.format = 0 // 输入框格式
                q.placeholder = ''
                q.decimalPlaces = 0
                break;
            case 206:
                q.questionsName = "我是简答";
                q.format = 0
                q.placeholder = ''
                q.inputHeight = '大'
                q.decimalPlaces = 0
                q.createDefaultOption();
                break;
            case 207:
                q.questionsName = "我是多项填空";
				q.optionIfRandom = 0 // 选项随机排列
				q.ifFixedLastOption = 0 // 固定最后一个选项
                q.createDefaultOption();
                break;
            case 208:
                q.questionsName = "我是横向填空";
                q.quesOptionTitle = `姓名________年龄____岁 联系方式___________` // 用于存储横向填空的填空部分
                let arr = q.quesOptionTitle.match(/_[_]+_/g)
                q.optionList = []
                q.matchingType = 1
                if(arr.length > 0) {
                    arr.forEach((info, index) => {
                    let obj = {
                        oid: UUID(),
                        answer: '',
                        length: info.length,
                        labelName: index + 1,
                        optionScore: 5,
                        format: 0, // 输入框格式
                        mustanswer: true,
                        maxNum: 0,
                        minNum: 0,
                        decimalPlaces: 0
                    }
                    q.optionList.push(obj)
                    })
                }
                break;
            case 209:
                q.questionsName = "绘图题";
                q.createDefaultOption();
                break;
            case 210:
                q.questionsName = "上传文件";
                q.createDefaultOption();
                break;
            // case 211:
            //     q.questionsName = "上传图片";
            //     q.createDefaultOption();
            //     break;
            case 600:
                q.decimalPlaces = 0
                switch (qLevel2Type){
                    case 601:
                        q.questionsName = "姓名";
                        break;
                    case 602:
                        q.questionsName = "学号";
                        break;
                    case 603:
                        q.questionsName = "专业";
                        break;
                    case 604:
                        q.questionsName = "院系";
                        break;
                    case 605:
                        q.questionsName = "学校";
                        break;
                    case 606:
                        q.questionsName = "其他信息";
                        break;
                }
                break;
            
            case 401:
                q.questionsName = "段落说明";
                break;
            case 402:
            case 404:
                if (qType == 402 && this.questionsList.length > 0 && this.questionsList[0].questionsTypeId != 402 && this.questionsList[0].questionsTypeId != 404)
                {
                    let quesPage = createPageObject(0, qType)
                    this.questionsList.unshift(quesPage)
                    this.pageCount++
                }
                q.questionsName = "页码";
                let index = 0
                this.questionsList.forEach((item, aaa) => {
                    if (item.questionsTypeId == 402 || item.questionsTypeId == 404) {
                        index++
                    }
                })
                q.pageIndex = index
                // console.log(q.pageIndex)
                this.pageCount++
                break;
            case 501:
                q.questionsName = "考前须知";
                q.text = `
                    <p>1、请在进入答题前，确保设备性能和系统条件符合线上考试要求</p>
                    <p>2、做题中请勿使用F功能键或查看源代码，如使用系统会记录下来</p>
                    <p>3、诚信考试，请勿上网搜索答案，与其他考生交流，求助外援等</p>
                    <p>4、做题中途遇到问题被退出，在有效期内仍可进入再次进行答题</p>
                `
                break;
        }

        //新添加的问题设置为编辑状态
        q.isedit = true
        if (qType == 404) {
            if (this.questionsList.length > 0) {
                const newList = [];
                let pageCounter = 0;
                
                this.questionsList.forEach((item, index) => {
                    // 跳过页码类型的项
                    if (item.questionsTypeId === 404 || item.questionsTypeId === 402) {
                        newList.push(item);
                        return;
                    }
                    
                    // 关键判断：如果前一项已经是页码，则不插入新页码
                    const prevItem = index > 0 ? this.questionsList[index - 1] : null;
                    const isPrevItemPage = prevItem && 
                        (prevItem.questionsTypeId === 404 || prevItem.questionsTypeId === 402);
                    
                    if (!isPrevItemPage) {
                        const page = createPageObject(pageCounter++, qType);
                        newList.push(page);
                    }
                    
                    newList.push(item);
                });
                
                this.questionsList = newList;
                
            } else {
                // 情况2：空列表的逻辑保持不变
                const newList = [];
                const frontPage = createPageObject(0, qType);
                newList.push(frontPage);
                newList.push(q);
                const backPage = createPageObject(1, qType);
                newList.push(backPage);
                this.questionsList = newList;
            }
        } else if (qType == 501){
            if (this.questionsList.length > 0 && 
                (this.questionsList[0].questionsTypeId === 404 || 
                this.questionsList[0].questionsTypeId === 402)) {
                // 首位是页码，插入到第二位
                this.questionsList.splice(1, 0, q);
            } else {
                // 首位不是页码或列表为空，插入到首位
                this.questionsList.unshift(q);
            }
        } else {
            if (this.questionsList.length > 0) {
                let result = false
                this.questionsList.forEach((info, index)=> {
                    if (this.quesAtive && info.qid == this.quesAtive) {
                        result = true
                    }
                })
                if (result == false) {
                    this.questionsList.push(q)
                } else {
                    if (qType == 600) {
                        const lastIndex = findLastIndex(this.questionsList, item => item.questionsTypeId == 501 || item.questionsTypeId == 600);
                        if (lastIndex != -1) {
                            this.questionsList.splice(lastIndex + 1, 0, q)
                        } else {
                            this.questionsList.unshift(q)
                        }
                    } else {
                        if (this.quesAtive.questionsTypeId == 600 || this.quesAtive.questionsTypeId == 501) {
                            this.questionsList.push(q)
                        } else {
                            this.questionsList.forEach((info, index)=> {
                                if (this.quesAtive && info.qid == this.quesAtive) {
                                    this.questionsList.splice(index + 1, 0, q)
                                }
                            })
                        }
                    }
                }
            } else {
                this.questionsList.push(q)
            }
        }
    }
    // 复制问题
    this.copyQuestion = function ( ques, index) {
        console.log(index)
        let question = JSON.parse(JSON.stringify(ques))
        question.qid = UUID()
        question.bqid = ''
        question.isedit = true
        this.questionsList.splice(index + 1,0,question);
        // console.log(this.questionsList)

    }
}

// 辅助函数：创建页码对象
function createPageObject(pageIndex, qType) {
    var page = new Question();
    page.qid = UUID();
    page.questionsTypeId = qType; // 页码类型，如 26
    page.questionsName = "页码";
    page.isedit = false;
    page.pageIndex = pageIndex;
    return page;
}

function findLastIndex(array, predicate) {
    for (let i = array.length - 1; i >= 0; i--) {
        if (predicate(array[i], i, array)) {
            return i;
        }
    }
    return -1;
}
export default Paper;